import { Column, SemanticModel } from "@pufflig/prompt-studio-types";
import { useSemanticModelStore } from "../SemanticModelProvider";

export const toggleColumnVisibility = (columnName: string) => {
  useSemanticModelStore.setState(
    (state) => {
      const { semanticModel, dbSchema, selectedTable } = state;
      if (!dbSchema || !selectedTable) return;

      let newSemanticModel: SemanticModel = semanticModel || {
        name: dbSchema.name,
        description: dbSchema.description,
        schemas: {},
        connectors: dbSchema.connectors || [],
      };

      const [schemaName, tableName] = selectedTable.split(".");

      if (!newSemanticModel.schemas[schemaName]) {
        newSemanticModel.schemas[schemaName] = {
          ...dbSchema.schemas[schemaName],
        };
      }

      if (!newSemanticModel.schemas[schemaName].tables?.[tableName]) {
        newSemanticModel.schemas[schemaName].tables = {
          ...(newSemanticModel.schemas[schemaName].tables || {}),
          [tableName]: {
            ...dbSchema.schemas[schemaName].tables[tableName],
          },
        };
      }

      const table = newSemanticModel.schemas[schemaName].tables[tableName];
      let columns = table.columns || [];
      const existingIdx = columns.findIndex((c) => c.columnName === columnName);

      if (existingIdx >= 0) {
        // hide column
        columns.splice(existingIdx, 1);
      } else {
        // unhide column
        const baseColumn = dbSchema.schemas[schemaName].tables[tableName].columns.find(
          (c) => c.columnName === columnName,
        );
        if (baseColumn) {
          columns.push(baseColumn);
        }
        // rule 2: unhide table when a column is unhidden
        table.hidden = false;
      }

      table.columns = columns;

      // rule 3: hide table if all columns hidden
      const connectorColumns = dbSchema.schemas[schemaName].tables[tableName].columns;
      const activeNames = new Set(columns.map((c) => c.columnName));
      const allHidden = connectorColumns.every((c) => !activeNames.has(c.columnName));
      if (allHidden) {
        table.hidden = true;
      }

      // rule 1: if table is hidden ensure all columns hidden
      if (table.hidden) {
        table.columns = [];
      }

      state.semanticModel = newSemanticModel;

      const merged: Column[] = connectorColumns.map((c) => {
        const m = table.columns.find((mc) => mc.columnName === c.columnName);
        return { ...c, ...(m || {}), hidden: !m } as Column;
      });
      state.selectedTableSchema = merged;
    },
    false,
    "column/toggle_visibility",
  );
};
